module.exports = __webpack_public_path__ + "media/hph-25-03_experiential-learning.c4772b92.mp4";